import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';

export const SearchbarFavouriteLocationLink = ({
  disabled,
  link,
  children,
}: {
  disabled: boolean;
  link: string;
  children: JSX.Element;
}) => {
  if (disabled) {
    <div className="SearchBar-favourites-list-item__content">{children}</div>;
  }

  return (
    <LinkFactoryReactRouter className="SearchBar-favourites-list-item__content" href={link}>
      {children}
    </LinkFactoryReactRouter>
  );
};
